module.exports = __webpack_public_path__ + "img/WE.47ae921d.png";